import * as React from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../context";
import { IContextApiModel } from "../apiModels/IContextApiModel";
import { RioResources, RioUnsafe, RioUserDropDownMenu, RioApiGet, RioIf, RioForEach } from "rio.react.all";
import { UserApiModel } from "../apiModels/UserApiModel";
import { SideMenu } from "../components/SideMenu";

interface ILayoutProps {

}

interface ILayoutState {
    UserDropdownClicked: boolean;
}

export class Layout extends React.Component<ILayoutProps, ILayoutState> {
    constructor(props: Readonly<ILayoutProps>) {
        super(props);

        this.state = {
            UserDropdownClicked: false
        };
    }

    render() {
        return (
            <React.Fragment>
                <header>
                    <div className="mobileSideMenuBurger">
                        <img src="/images/burger54.png" alt="Menu" />
                    </div>
                    <Link to="/campaigns" className="logo">
                        <img src="/images/logo-stacked.png" alt="Goedhuis Waddesdon" />
                    </Link>

                    <GlobalContext.Consumer>
                        {(globals: IContextApiModel) => (
                            <div id="userDropdown" className="user" onClick={(e) => this.handleUserDropdownClicked(e)}>
                                <div className="header-user-user-main">
                                    <span className="initials">{globals.user.firstName.charAt(0)}{globals.user.lastName.charAt(0)}</span>
                                    <p className="details">
                                        <span className="name">{globals.user.firstName} {globals.user.lastName}</span>
                                        <span className="title">{globals.user.jobTitle}</span>
                                    </p>
                                    <RioUnsafe html={RioResources.find("UserMenuDownIcon").image} />
                                </div>
                                <RioIf condition={this.state.UserDropdownClicked} then={
                                    <RioUserDropDownMenu show={true} menuItemEndpoint="/api/context/menu/2" />
                                } />
                            </div>
                        )}
                    </GlobalContext.Consumer>
                    
                </header>

                <nav className="sideMenu">
                    <SideMenu menuItemEndpoint="/api/context/menu/1" />
                </nav>

                <main>
                    {this.props.children}
                </main>

                <footer>
                    <div className="poweredBy">
                    </div>
                    <GlobalContext.Consumer>
                        {(globals: IContextApiModel) => (
                            <div>
                                {globals.version} &copy; GOEDHUIS WADDESDON LTD 2024
                            </div>
                        )}
                    </GlobalContext.Consumer>
                </footer>
            </React.Fragment>
        );
    }

    componentDidMount() {
        
    }

    handleUserDropdownClicked(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        e.currentTarget.classList.toggle("is-active")
        this.setState({
            UserDropdownClicked: !this.state.UserDropdownClicked
        });
    }
}
